export const LANGUAGES = [
  {
    "code": "pt-BR",
    "name": "Português"
  },
  {
    "code": "en",
    "name": "English"
  },
  {
    "code": "es",
    "name": "Español"
  },
  {
    "code": "fr",
    "name": "Français"
  },
  {
    "code": "de",
    "name": "Deutsch"
  },
  {
    "code": "it",
    "name": "Italiano"
  },
  {
    "code": "ja",
    "name": "日本語"
  },
  {
    "code": "zh-CN",
    "name": "简体中文"
  }
]

export const COUNTRY_LANGUAGE_MAP = {
  "AO": "pt-BR",
  "AR": "es",
  "AT": "de",
  "AU": "en",
  "BE": "fr",
  "BF": "fr",
  "BJ": "fr",
  "BO": "es",
  "BR": "pt-BR",
  "CA": "en",
  "CD": "fr",
  "CG": "fr",
  "CH": "de",
  "CI": "fr",
  "CL": "es",
  "CM": "fr",
  "CN": "zh-CN",
  "CO": "es",
  "CR": "es",
  "CU": "es",
  "CV": "pt-BR",
  "DE": "de",
  "DO": "es",
  "EC": "es",
  "ES": "es",
  "FR": "fr",
  "GA": "fr",
  "GB": "en",
  "GQ": "es",
  "GT": "es",
  "GW": "pt-BR",
  "HK": "zh-CN",
  "HN": "es",
  "HT": "fr",
  "IE": "en",
  "IN": "en",
  "IT": "it",
  "JP": "ja",
  "LI": "de",
  "LU": "fr",
  "MC": "fr",
  "MG": "fr",
  "ML": "fr",
  "MO": "zh-CN",
  "MX": "es",
  "MZ": "pt-BR",
  "NE": "fr",
  "NI": "es",
  "NZ": "en",
  "PA": "es",
  "PE": "es",
  "PH": "en",
  "PT": "pt-BR",
  "PY": "es",
  "SG": "zh-CN",
  "SM": "it",
  "SN": "fr",
  "ST": "pt-BR",
  "SV": "es",
  "TG": "fr",
  "TL": "pt-BR",
  "TW": "zh-CN",
  "US": "en",
  "UY": "es",
  "VA": "it",
  "VE": "es",
  "ZA": "en"
}

export const MESSAGES = {
  "pt-BR": {
    "metaHomeTitle": "Let Me Ask AI For You — transforme perguntas em links",
    "metaHomeDescription": "Crie um link elegante que digita uma pergunta e abre o ChatGPT automaticamente.",
    "metaPlayerTitle": "Preparando sua pergunta… — Let Me Ask AI For You",
    "themeLight": "Usar tema claro",
    "themeDark": "Usar tema escuro",
    "language": "Idioma",
    "automatic": "Automático",
    "privacyPill": "Sem API · sem cadastro",
    "eyebrow": "Uma forma mais divertida de responder",
    "heroPrefix": "Deixe a",
    "heroAccent": "IA explicar",
    "heroSuffix": "por você.",
    "heroCopy": "Crie um link que digita a pergunta na tela e, no final, abre o ChatGPT com tudo pronto.",
    "questionLabel": "O que a pessoa deveria perguntar?",
    "questionPlaceholder": "Ex.: Explique de forma simples por que o céu é azul.",
    "typingRhythm": "Ritmo da digitação",
    "speedFast": "Rápida",
    "speedNormal": "Natural",
    "speedSlow": "Dramática",
    "createMagicLink": "Criar link mágico",
    "shortcut": "para criar o link",
    "resultReady": "Seu link está pronto",
    "resultTitle": "Agora é só mandar.",
    "resultBody": "A pessoa verá a pergunta sendo digitada antes de chegar ao ChatGPT.",
    "copy": "Copiar",
    "copied": "Copiado!",
    "preview": "Ver prévia",
    "testRealLink": "Testar link real",
    "share": "Compartilhar",
    "promptInLink": "Pergunta no link",
    "simplePurpose": "Simples de propósito",
    "stepsTitle": "Três passos. Um efeito memorável.",
    "step1Title": "Escreva a pergunta",
    "step1Body": "Use qualquer pergunta que caiba em um link, sem cadastro e sem chave de API.",
    "step2Title": "Compartilhe a cena",
    "step2Body": "O destinatário acompanha uma animação elegante de digitação, em qualquer tela.",
    "step3Title": "Abra o ChatGPT",
    "step3Body": "No final, o navegador segue para o ChatGPT levando a pergunta no endereço.",
    "privacyLabel": "Privacidade por design",
    "privacyTitle": "Nada é enviado para um servidor nosso.",
    "privacyBody": "A pergunta fica codificada no próprio link. Este projeto não usa banco de dados, cookies de rastreamento ou uma chave da OpenAI.",
    "footerIndependent": "Projeto independente. Não afiliado à OpenAI ou ao ChatGPT.",
    "openChatGPT": "Abrir ChatGPT",
    "homeAria": "Let Me Ask AI For You — início",
    "toastWritePrompt": "Escreva uma pergunta primeiro.",
    "toastLinkCopied": "Link copiado para a área de transferência.",
    "toastManualCopy": "Selecione e copie o link manualmente.",
    "toastShareFailed": "Não foi possível abrir o compartilhamento.",
    "shareTitle": "Deixa que a IA explica",
    "shareText": "Veja esta pergunta sendo feita ao ChatGPT:",
    "navIllustrative": "Navegação ilustrativa",
    "shortcutsIllustrative": "Atalhos ilustrativos",
    "newChat": "Novo chat",
    "searchChats": "Buscar chats",
    "images": "Imagens",
    "plugins": "Plugins",
    "research": "Investigação",
    "optionsIllustrative": "Opções ilustrativas",
    "plans": "Confira planos e preços",
    "settings": "Configurações",
    "help": "Ajuda",
    "loginTitle": "Receba respostas personalizadas para você",
    "loginBody": "Entre para receber respostas com base em chats salvos, além de criar imagens e carregar arquivos.",
    "signIn": "Entrar",
    "signUp": "Cadastre-se grátis",
    "askAnything": "Pergunte alguma coisa",
    "composerAria": "Compositor de mensagem ilustrativo",
    "questionTyping": "Pergunta sendo digitada",
    "disclaimer": "O ChatGPT pode cometer erros. Confira informações importantes.",
    "controlsAria": "Controles da simulação",
    "pauseAnimation": "Pausar animação",
    "pause": "Pausar",
    "skipAnimation": "Pular animação",
    "skip": "Pular",
    "createAnother": "Criar outro link",
    "createLinkShort": "Criar link",
    "statusTypingQuestion": "Digitando a pergunta",
    "statusPreparing": "Preparando",
    "unofficialNote": "Simulação visual independente · não afiliada à OpenAI",
    "fallbackTitle": "Pronto para continuar",
    "fallbackBody": "Use o botão abaixo caso o redirecionamento não aconteça automaticamente.",
    "copyQuestion": "Copiar pergunta",
    "statusOpeningConversation": "Abrindo a conversa…",
    "statusPreviewDone": "Prévia concluída",
    "statusOpeningChatGPT": "Abrindo o ChatGPT…",
    "statusSendingChatGPT": "Enviando ao ChatGPT",
    "statusTyping": "Digitando",
    "statusQuestionComplete": "Pergunta completa",
    "statusQuestionReady": "Pergunta pronta",
    "statusPaused": "Animação pausada",
    "statusQuestionCopied": "Pergunta copiada.",
    "continueAnimation": "Continuar animação",
    "continue": "Continuar",
    "openInChatGPT": "Abrir no ChatGPT",
    "simulation": "Simulação",
    "autoDetected": "Automático: {language}"
  },
  "en": {
    "metaHomeTitle": "Let Me Ask AI For You — turn questions into links",
    "metaHomeDescription": "Create an elegant link that types a question and opens ChatGPT automatically.",
    "metaPlayerTitle": "Preparing your question… — Let Me Ask AI For You",
    "themeLight": "Use light theme",
    "themeDark": "Use dark theme",
    "language": "Language",
    "automatic": "Automatic",
    "privacyPill": "No API · no sign-up",
    "eyebrow": "A more entertaining way to reply",
    "heroPrefix": "Let",
    "heroAccent": "AI explain it",
    "heroSuffix": "for you.",
    "heroCopy": "Create a link that types the question on screen and then opens ChatGPT with everything ready.",
    "questionLabel": "What should the person ask?",
    "questionPlaceholder": "Example: Explain in simple terms why the sky is blue.",
    "typingRhythm": "Typing pace",
    "speedFast": "Fast",
    "speedNormal": "Natural",
    "speedSlow": "Dramatic",
    "createMagicLink": "Create magic link",
    "shortcut": "to create the link",
    "resultReady": "Your link is ready",
    "resultTitle": "Now just send it.",
    "resultBody": "They will see the question being typed before arriving at ChatGPT.",
    "copy": "Copy",
    "copied": "Copied!",
    "preview": "Preview",
    "testRealLink": "Test real link",
    "share": "Share",
    "promptInLink": "Question in the link",
    "simplePurpose": "Intentionally simple",
    "stepsTitle": "Three steps. One memorable effect.",
    "step1Title": "Write the question",
    "step1Body": "Use any question that fits in a link, with no account or API key.",
    "step2Title": "Share the scene",
    "step2Body": "The recipient watches an elegant typing animation on any screen.",
    "step3Title": "Open ChatGPT",
    "step3Body": "At the end, the browser opens ChatGPT with the question in the address.",
    "privacyLabel": "Privacy by design",
    "privacyTitle": "Nothing is sent to our server.",
    "privacyBody": "The question is encoded in the link itself. This project uses no database, tracking cookies, or OpenAI key.",
    "footerIndependent": "Independent project. Not affiliated with OpenAI or ChatGPT.",
    "openChatGPT": "Open ChatGPT",
    "homeAria": "Let Me Ask AI For You — home",
    "toastWritePrompt": "Write a question first.",
    "toastLinkCopied": "Link copied to the clipboard.",
    "toastManualCopy": "Select and copy the link manually.",
    "toastShareFailed": "Could not open the share menu.",
    "shareTitle": "Let AI explain it",
    "shareText": "Watch this question being asked to ChatGPT:",
    "navIllustrative": "Illustrative navigation",
    "shortcutsIllustrative": "Illustrative shortcuts",
    "newChat": "New chat",
    "searchChats": "Search chats",
    "images": "Images",
    "plugins": "Plugins",
    "research": "Research",
    "optionsIllustrative": "Illustrative options",
    "plans": "View plans and pricing",
    "settings": "Settings",
    "help": "Help",
    "loginTitle": "Get personalized answers",
    "loginBody": "Sign in for answers based on saved chats, plus image creation and file uploads.",
    "signIn": "Log in",
    "signUp": "Sign up for free",
    "askAnything": "Ask anything",
    "composerAria": "Illustrative message composer",
    "questionTyping": "Question being typed",
    "disclaimer": "ChatGPT can make mistakes. Check important information.",
    "controlsAria": "Simulation controls",
    "pauseAnimation": "Pause animation",
    "pause": "Pause",
    "skipAnimation": "Skip animation",
    "skip": "Skip",
    "createAnother": "Create another link",
    "createLinkShort": "Create link",
    "statusTypingQuestion": "Typing the question",
    "statusPreparing": "Preparing",
    "unofficialNote": "Independent visual simulation · not affiliated with OpenAI",
    "fallbackTitle": "Ready to continue",
    "fallbackBody": "Use the button below if the redirect does not happen automatically.",
    "copyQuestion": "Copy question",
    "statusOpeningConversation": "Opening the conversation…",
    "statusPreviewDone": "Preview complete",
    "statusOpeningChatGPT": "Opening ChatGPT…",
    "statusSendingChatGPT": "Sending to ChatGPT",
    "statusTyping": "Typing",
    "statusQuestionComplete": "Question complete",
    "statusQuestionReady": "Question ready",
    "statusPaused": "Animation paused",
    "statusQuestionCopied": "Question copied.",
    "continueAnimation": "Resume animation",
    "continue": "Resume",
    "openInChatGPT": "Open in ChatGPT",
    "simulation": "Simulation",
    "autoDetected": "Automatic: {language}"
  },
  "es": {
    "metaHomeTitle": "Let Me Ask AI For You — convierte preguntas en enlaces",
    "metaHomeDescription": "Crea un enlace elegante que escribe una pregunta y abre ChatGPT automáticamente.",
    "metaPlayerTitle": "Preparando tu pregunta… — Let Me Ask AI For You",
    "themeLight": "Usar tema claro",
    "themeDark": "Usar tema oscuro",
    "language": "Idioma",
    "automatic": "Automático",
    "privacyPill": "Sin API · sin registro",
    "eyebrow": "Una forma más divertida de responder",
    "heroPrefix": "Deja que la",
    "heroAccent": "IA lo explique",
    "heroSuffix": "por ti.",
    "heroCopy": "Crea un enlace que escribe la pregunta en pantalla y después abre ChatGPT con todo listo.",
    "questionLabel": "¿Qué debería preguntar la persona?",
    "questionPlaceholder": "Ej.: Explica de forma sencilla por qué el cielo es azul.",
    "typingRhythm": "Ritmo de escritura",
    "speedFast": "Rápido",
    "speedNormal": "Natural",
    "speedSlow": "Dramático",
    "createMagicLink": "Crear enlace mágico",
    "shortcut": "para crear el enlace",
    "resultReady": "Tu enlace está listo",
    "resultTitle": "Ahora solo envíalo.",
    "resultBody": "La persona verá cómo se escribe la pregunta antes de llegar a ChatGPT.",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "preview": "Ver vista previa",
    "testRealLink": "Probar enlace real",
    "share": "Compartir",
    "promptInLink": "Pregunta del enlace",
    "simplePurpose": "Simple a propósito",
    "stepsTitle": "Tres pasos. Un efecto memorable.",
    "step1Title": "Escribe la pregunta",
    "step1Body": "Usa cualquier pregunta que quepa en un enlace, sin registro ni clave de API.",
    "step2Title": "Comparte la escena",
    "step2Body": "El destinatario verá una elegante animación de escritura en cualquier pantalla.",
    "step3Title": "Abre ChatGPT",
    "step3Body": "Al final, el navegador abre ChatGPT con la pregunta en la dirección.",
    "privacyLabel": "Privacidad desde el diseño",
    "privacyTitle": "Nada se envía a nuestro servidor.",
    "privacyBody": "La pregunta queda codificada en el propio enlace. Este proyecto no usa base de datos, cookies de seguimiento ni una clave de OpenAI.",
    "footerIndependent": "Proyecto independiente. No afiliado a OpenAI ni a ChatGPT.",
    "openChatGPT": "Abrir ChatGPT",
    "homeAria": "Let Me Ask AI For You — inicio",
    "toastWritePrompt": "Escribe primero una pregunta.",
    "toastLinkCopied": "Enlace copiado al portapapeles.",
    "toastManualCopy": "Selecciona y copia el enlace manualmente.",
    "toastShareFailed": "No se pudo abrir el menú para compartir.",
    "shareTitle": "Deja que la IA lo explique",
    "shareText": "Mira cómo se hace esta pregunta a ChatGPT:",
    "navIllustrative": "Navegación ilustrativa",
    "shortcutsIllustrative": "Accesos ilustrativos",
    "newChat": "Nuevo chat",
    "searchChats": "Buscar chats",
    "images": "Imágenes",
    "plugins": "Plugins",
    "research": "Investigación",
    "optionsIllustrative": "Opciones ilustrativas",
    "plans": "Ver planes y precios",
    "settings": "Configuración",
    "help": "Ayuda",
    "loginTitle": "Recibe respuestas personalizadas",
    "loginBody": "Inicia sesión para obtener respuestas basadas en chats guardados, crear imágenes y subir archivos.",
    "signIn": "Iniciar sesión",
    "signUp": "Regístrate gratis",
    "askAnything": "Pregunta lo que quieras",
    "composerAria": "Compositor de mensajes ilustrativo",
    "questionTyping": "Pregunta en proceso de escritura",
    "disclaimer": "ChatGPT puede cometer errores. Comprueba la información importante.",
    "controlsAria": "Controles de la simulación",
    "pauseAnimation": "Pausar animación",
    "pause": "Pausar",
    "skipAnimation": "Saltar animación",
    "skip": "Saltar",
    "createAnother": "Crear otro enlace",
    "createLinkShort": "Crear enlace",
    "statusTypingQuestion": "Escribiendo la pregunta",
    "statusPreparing": "Preparando",
    "unofficialNote": "Simulación visual independiente · no afiliada a OpenAI",
    "fallbackTitle": "Listo para continuar",
    "fallbackBody": "Usa el botón de abajo si la redirección no ocurre automáticamente.",
    "copyQuestion": "Copiar pregunta",
    "statusOpeningConversation": "Abriendo la conversación…",
    "statusPreviewDone": "Vista previa completada",
    "statusOpeningChatGPT": "Abriendo ChatGPT…",
    "statusSendingChatGPT": "Enviando a ChatGPT",
    "statusTyping": "Escribiendo",
    "statusQuestionComplete": "Pregunta completa",
    "statusQuestionReady": "Pregunta lista",
    "statusPaused": "Animación pausada",
    "statusQuestionCopied": "Pregunta copiada.",
    "continueAnimation": "Continuar animación",
    "continue": "Continuar",
    "openInChatGPT": "Abrir en ChatGPT",
    "simulation": "Simulación",
    "autoDetected": "Automático: {language}"
  },
  "fr": {
    "metaHomeTitle": "Let Me Ask AI For You — transformez vos questions en liens",
    "metaHomeDescription": "Créez un lien élégant qui saisit une question et ouvre ChatGPT automatiquement.",
    "metaPlayerTitle": "Préparation de votre question… — Let Me Ask AI For You",
    "themeLight": "Utiliser le thème clair",
    "themeDark": "Utiliser le thème sombre",
    "language": "Langue",
    "automatic": "Automatique",
    "privacyPill": "Sans API · sans inscription",
    "eyebrow": "Une manière plus amusante de répondre",
    "heroPrefix": "Laissez",
    "heroAccent": "l’IA expliquer",
    "heroSuffix": "à votre place.",
    "heroCopy": "Créez un lien qui saisit la question à l’écran, puis ouvre ChatGPT avec tout prêt.",
    "questionLabel": "Que devrait demander la personne ?",
    "questionPlaceholder": "Ex. : Explique simplement pourquoi le ciel est bleu.",
    "typingRhythm": "Rythme de saisie",
    "speedFast": "Rapide",
    "speedNormal": "Naturel",
    "speedSlow": "Dramatique",
    "createMagicLink": "Créer le lien magique",
    "shortcut": "pour créer le lien",
    "resultReady": "Votre lien est prêt",
    "resultTitle": "Il ne reste qu’à l’envoyer.",
    "resultBody": "La personne verra la question se saisir avant d’arriver sur ChatGPT.",
    "copy": "Copier",
    "copied": "Copié !",
    "preview": "Aperçu",
    "testRealLink": "Tester le vrai lien",
    "share": "Partager",
    "promptInLink": "Question du lien",
    "simplePurpose": "Simple par choix",
    "stepsTitle": "Trois étapes. Un effet mémorable.",
    "step1Title": "Écrivez la question",
    "step1Body": "Utilisez toute question tenant dans un lien, sans compte ni clé API.",
    "step2Title": "Partagez la scène",
    "step2Body": "Le destinataire voit une élégante animation de saisie sur tout écran.",
    "step3Title": "Ouvrez ChatGPT",
    "step3Body": "À la fin, le navigateur ouvre ChatGPT avec la question dans l’adresse.",
    "privacyLabel": "Confidentialité dès la conception",
    "privacyTitle": "Rien n’est envoyé à notre serveur.",
    "privacyBody": "La question est encodée dans le lien lui-même. Ce projet n’utilise ni base de données, ni cookies de suivi, ni clé OpenAI.",
    "footerIndependent": "Projet indépendant. Non affilié à OpenAI ou ChatGPT.",
    "openChatGPT": "Ouvrir ChatGPT",
    "homeAria": "Let Me Ask AI For You — accueil",
    "toastWritePrompt": "Écrivez d’abord une question.",
    "toastLinkCopied": "Lien copié dans le presse-papiers.",
    "toastManualCopy": "Sélectionnez et copiez le lien manuellement.",
    "toastShareFailed": "Impossible d’ouvrir le partage.",
    "shareTitle": "Laissez l’IA expliquer",
    "shareText": "Regardez cette question être posée à ChatGPT :",
    "navIllustrative": "Navigation illustrative",
    "shortcutsIllustrative": "Raccourcis illustratifs",
    "newChat": "Nouveau chat",
    "searchChats": "Rechercher des chats",
    "images": "Images",
    "plugins": "Plugins",
    "research": "Recherche",
    "optionsIllustrative": "Options illustratives",
    "plans": "Voir les offres et tarifs",
    "settings": "Paramètres",
    "help": "Aide",
    "loginTitle": "Obtenez des réponses personnalisées",
    "loginBody": "Connectez-vous pour des réponses fondées sur vos chats enregistrés, créer des images et importer des fichiers.",
    "signIn": "Se connecter",
    "signUp": "S’inscrire gratuitement",
    "askAnything": "Posez une question",
    "composerAria": "Zone de message illustrative",
    "questionTyping": "Question en cours de saisie",
    "disclaimer": "ChatGPT peut faire des erreurs. Vérifiez les informations importantes.",
    "controlsAria": "Commandes de la simulation",
    "pauseAnimation": "Mettre l’animation en pause",
    "pause": "Pause",
    "skipAnimation": "Passer l’animation",
    "skip": "Passer",
    "createAnother": "Créer un autre lien",
    "createLinkShort": "Créer un lien",
    "statusTypingQuestion": "Saisie de la question",
    "statusPreparing": "Préparation",
    "unofficialNote": "Simulation visuelle indépendante · non affiliée à OpenAI",
    "fallbackTitle": "Prêt à continuer",
    "fallbackBody": "Utilisez le bouton ci-dessous si la redirection ne se produit pas automatiquement.",
    "copyQuestion": "Copier la question",
    "statusOpeningConversation": "Ouverture de la conversation…",
    "statusPreviewDone": "Aperçu terminé",
    "statusOpeningChatGPT": "Ouverture de ChatGPT…",
    "statusSendingChatGPT": "Envoi à ChatGPT",
    "statusTyping": "Saisie",
    "statusQuestionComplete": "Question complète",
    "statusQuestionReady": "Question prête",
    "statusPaused": "Animation en pause",
    "statusQuestionCopied": "Question copiée.",
    "continueAnimation": "Reprendre l’animation",
    "continue": "Reprendre",
    "openInChatGPT": "Ouvrir dans ChatGPT",
    "simulation": "Simulation",
    "autoDetected": "Automatique : {language}"
  },
  "de": {
    "metaHomeTitle": "Let Me Ask AI For You — Fragen in Links verwandeln",
    "metaHomeDescription": "Erstelle einen eleganten Link, der eine Frage tippt und ChatGPT automatisch öffnet.",
    "metaPlayerTitle": "Deine Frage wird vorbereitet… — Let Me Ask AI For You",
    "themeLight": "Helles Design verwenden",
    "themeDark": "Dunkles Design verwenden",
    "language": "Sprache",
    "automatic": "Automatisch",
    "privacyPill": "Keine API · keine Anmeldung",
    "eyebrow": "Eine unterhaltsamere Art zu antworten",
    "heroPrefix": "Lass die",
    "heroAccent": "KI es erklären",
    "heroSuffix": "für dich.",
    "heroCopy": "Erstelle einen Link, der die Frage auf dem Bildschirm tippt und anschließend ChatGPT startklar öffnet.",
    "questionLabel": "Was soll die Person fragen?",
    "questionPlaceholder": "Beispiel: Erkläre einfach, warum der Himmel blau ist.",
    "typingRhythm": "Tippgeschwindigkeit",
    "speedFast": "Schnell",
    "speedNormal": "Natürlich",
    "speedSlow": "Dramatisch",
    "createMagicLink": "Magischen Link erstellen",
    "shortcut": "zum Erstellen des Links",
    "resultReady": "Dein Link ist fertig",
    "resultTitle": "Jetzt nur noch senden.",
    "resultBody": "Die Person sieht, wie die Frage getippt wird, bevor ChatGPT geöffnet wird.",
    "copy": "Kopieren",
    "copied": "Kopiert!",
    "preview": "Vorschau",
    "testRealLink": "Echten Link testen",
    "share": "Teilen",
    "promptInLink": "Frage im Link",
    "simplePurpose": "Bewusst einfach",
    "stepsTitle": "Drei Schritte. Ein bleibender Effekt.",
    "step1Title": "Frage schreiben",
    "step1Body": "Nutze jede Frage, die in einen Link passt — ohne Konto oder API-Schlüssel.",
    "step2Title": "Szene teilen",
    "step2Body": "Der Empfänger sieht auf jedem Bildschirm eine elegante Tippanimation.",
    "step3Title": "ChatGPT öffnen",
    "step3Body": "Am Ende öffnet der Browser ChatGPT mit der Frage in der Adresse.",
    "privacyLabel": "Datenschutz von Anfang an",
    "privacyTitle": "Nichts wird an unseren Server gesendet.",
    "privacyBody": "Die Frage ist direkt im Link codiert. Dieses Projekt nutzt keine Datenbank, Tracking-Cookies oder einen OpenAI-Schlüssel.",
    "footerIndependent": "Unabhängiges Projekt. Nicht mit OpenAI oder ChatGPT verbunden.",
    "openChatGPT": "ChatGPT öffnen",
    "homeAria": "Let Me Ask AI For You — Startseite",
    "toastWritePrompt": "Schreibe zuerst eine Frage.",
    "toastLinkCopied": "Link in die Zwischenablage kopiert.",
    "toastManualCopy": "Markiere und kopiere den Link manuell.",
    "toastShareFailed": "Teilen konnte nicht geöffnet werden.",
    "shareTitle": "Lass die KI es erklären",
    "shareText": "Sieh zu, wie diese Frage an ChatGPT gestellt wird:",
    "navIllustrative": "Beispielnavigation",
    "shortcutsIllustrative": "Beispielverknüpfungen",
    "newChat": "Neuer Chat",
    "searchChats": "Chats durchsuchen",
    "images": "Bilder",
    "plugins": "Plugins",
    "research": "Recherche",
    "optionsIllustrative": "Beispieloptionen",
    "plans": "Tarife und Preise ansehen",
    "settings": "Einstellungen",
    "help": "Hilfe",
    "loginTitle": "Personalisierte Antworten erhalten",
    "loginBody": "Melde dich an für Antworten auf Basis gespeicherter Chats sowie Bilderstellung und Datei-Uploads.",
    "signIn": "Anmelden",
    "signUp": "Kostenlos registrieren",
    "askAnything": "Frag etwas",
    "composerAria": "Beispielhafter Nachrichtenbereich",
    "questionTyping": "Frage wird getippt",
    "disclaimer": "ChatGPT kann Fehler machen. Prüfe wichtige Informationen.",
    "controlsAria": "Simulationssteuerung",
    "pauseAnimation": "Animation pausieren",
    "pause": "Pausieren",
    "skipAnimation": "Animation überspringen",
    "skip": "Überspringen",
    "createAnother": "Weiteren Link erstellen",
    "createLinkShort": "Link erstellen",
    "statusTypingQuestion": "Frage wird getippt",
    "statusPreparing": "Vorbereitung",
    "unofficialNote": "Unabhängige visuelle Simulation · nicht mit OpenAI verbunden",
    "fallbackTitle": "Bereit zum Fortfahren",
    "fallbackBody": "Nutze die Schaltfläche unten, falls die Weiterleitung nicht automatisch erfolgt.",
    "copyQuestion": "Frage kopieren",
    "statusOpeningConversation": "Unterhaltung wird geöffnet…",
    "statusPreviewDone": "Vorschau abgeschlossen",
    "statusOpeningChatGPT": "ChatGPT wird geöffnet…",
    "statusSendingChatGPT": "Wird an ChatGPT gesendet",
    "statusTyping": "Tippen",
    "statusQuestionComplete": "Frage vollständig",
    "statusQuestionReady": "Frage bereit",
    "statusPaused": "Animation pausiert",
    "statusQuestionCopied": "Frage kopiert.",
    "continueAnimation": "Animation fortsetzen",
    "continue": "Fortsetzen",
    "openInChatGPT": "In ChatGPT öffnen",
    "simulation": "Simulation",
    "autoDetected": "Automatisch: {language}"
  },
  "it": {
    "metaHomeTitle": "Let Me Ask AI For You — trasforma le domande in link",
    "metaHomeDescription": "Crea un link elegante che digita una domanda e apre ChatGPT automaticamente.",
    "metaPlayerTitle": "Preparazione della domanda… — Let Me Ask AI For You",
    "themeLight": "Usa tema chiaro",
    "themeDark": "Usa tema scuro",
    "language": "Lingua",
    "automatic": "Automatico",
    "privacyPill": "Senza API · senza registrazione",
    "eyebrow": "Un modo più divertente di rispondere",
    "heroPrefix": "Lascia che",
    "heroAccent": "l’IA lo spieghi",
    "heroSuffix": "per te.",
    "heroCopy": "Crea un link che digita la domanda sullo schermo e poi apre ChatGPT con tutto pronto.",
    "questionLabel": "Cosa dovrebbe chiedere la persona?",
    "questionPlaceholder": "Es.: Spiega in modo semplice perché il cielo è blu.",
    "typingRhythm": "Ritmo di digitazione",
    "speedFast": "Veloce",
    "speedNormal": "Naturale",
    "speedSlow": "Drammatico",
    "createMagicLink": "Crea link magico",
    "shortcut": "per creare il link",
    "resultReady": "Il tuo link è pronto",
    "resultTitle": "Ora basta inviarlo.",
    "resultBody": "La persona vedrà la domanda digitata prima di arrivare su ChatGPT.",
    "copy": "Copia",
    "copied": "Copiato!",
    "preview": "Anteprima",
    "testRealLink": "Prova link reale",
    "share": "Condividi",
    "promptInLink": "Domanda nel link",
    "simplePurpose": "Semplice di proposito",
    "stepsTitle": "Tre passaggi. Un effetto memorabile.",
    "step1Title": "Scrivi la domanda",
    "step1Body": "Usa qualsiasi domanda che entri in un link, senza account né chiave API.",
    "step2Title": "Condividi la scena",
    "step2Body": "Il destinatario guarda un’elegante animazione di digitazione su ogni schermo.",
    "step3Title": "Apri ChatGPT",
    "step3Body": "Alla fine, il browser apre ChatGPT con la domanda nell’indirizzo.",
    "privacyLabel": "Privacy by design",
    "privacyTitle": "Nulla viene inviato al nostro server.",
    "privacyBody": "La domanda è codificata nel link stesso. Il progetto non usa database, cookie di tracciamento o chiavi OpenAI.",
    "footerIndependent": "Progetto indipendente. Non affiliato a OpenAI o ChatGPT.",
    "openChatGPT": "Apri ChatGPT",
    "homeAria": "Let Me Ask AI For You — home",
    "toastWritePrompt": "Scrivi prima una domanda.",
    "toastLinkCopied": "Link copiato negli appunti.",
    "toastManualCopy": "Seleziona e copia il link manualmente.",
    "toastShareFailed": "Impossibile aprire la condivisione.",
    "shareTitle": "Lascia che l’IA lo spieghi",
    "shareText": "Guarda questa domanda mentre viene posta a ChatGPT:",
    "navIllustrative": "Navigazione illustrativa",
    "shortcutsIllustrative": "Scorciatoie illustrative",
    "newChat": "Nuova chat",
    "searchChats": "Cerca chat",
    "images": "Immagini",
    "plugins": "Plugin",
    "research": "Ricerca",
    "optionsIllustrative": "Opzioni illustrative",
    "plans": "Vedi piani e prezzi",
    "settings": "Impostazioni",
    "help": "Aiuto",
    "loginTitle": "Ricevi risposte personalizzate",
    "loginBody": "Accedi per ricevere risposte basate sulle chat salvate, creare immagini e caricare file.",
    "signIn": "Accedi",
    "signUp": "Registrati gratis",
    "askAnything": "Chiedi qualsiasi cosa",
    "composerAria": "Compositore di messaggi illustrativo",
    "questionTyping": "Domanda in digitazione",
    "disclaimer": "ChatGPT può commettere errori. Verifica le informazioni importanti.",
    "controlsAria": "Controlli della simulazione",
    "pauseAnimation": "Metti in pausa l’animazione",
    "pause": "Pausa",
    "skipAnimation": "Salta animazione",
    "skip": "Salta",
    "createAnother": "Crea un altro link",
    "createLinkShort": "Crea link",
    "statusTypingQuestion": "Digitazione della domanda",
    "statusPreparing": "Preparazione",
    "unofficialNote": "Simulazione visiva indipendente · non affiliata a OpenAI",
    "fallbackTitle": "Pronto per continuare",
    "fallbackBody": "Usa il pulsante qui sotto se il reindirizzamento non avviene automaticamente.",
    "copyQuestion": "Copia domanda",
    "statusOpeningConversation": "Apertura della conversazione…",
    "statusPreviewDone": "Anteprima completata",
    "statusOpeningChatGPT": "Apertura di ChatGPT…",
    "statusSendingChatGPT": "Invio a ChatGPT",
    "statusTyping": "Digitazione",
    "statusQuestionComplete": "Domanda completa",
    "statusQuestionReady": "Domanda pronta",
    "statusPaused": "Animazione in pausa",
    "statusQuestionCopied": "Domanda copiata.",
    "continueAnimation": "Riprendi animazione",
    "continue": "Riprendi",
    "openInChatGPT": "Apri in ChatGPT",
    "simulation": "Simulazione",
    "autoDetected": "Automatico: {language}"
  },
  "ja": {
    "metaHomeTitle": "Let Me Ask AI For You — 質問をリンクに変換",
    "metaHomeDescription": "質問を入力するアニメーションの後、ChatGPTを自動で開くリンクを作成します。",
    "metaPlayerTitle": "質問を準備しています… — Let Me Ask AI For You",
    "themeLight": "ライトテーマを使用",
    "themeDark": "ダークテーマを使用",
    "language": "言語",
    "automatic": "自動",
    "privacyPill": "API不要・登録不要",
    "eyebrow": "もっと楽しく答える方法",
    "heroPrefix": "説明は",
    "heroAccent": "AIに",
    "heroSuffix": "任せよう。",
    "heroCopy": "画面上で質問を入力し、すべて準備された状態でChatGPTを開くリンクを作成します。",
    "questionLabel": "相手に何を質問してほしいですか？",
    "questionPlaceholder": "例：空が青い理由をわかりやすく説明して。",
    "typingRhythm": "入力速度",
    "speedFast": "速い",
    "speedNormal": "自然",
    "speedSlow": "ドラマチック",
    "createMagicLink": "魔法のリンクを作成",
    "shortcut": "でリンクを作成",
    "resultReady": "リンクができました",
    "resultTitle": "あとは送るだけ。",
    "resultBody": "相手はChatGPTへ移動する前に、質問が入力される様子を見られます。",
    "copy": "コピー",
    "copied": "コピーしました！",
    "preview": "プレビュー",
    "testRealLink": "実際のリンクを試す",
    "share": "共有",
    "promptInLink": "リンク内の質問",
    "simplePurpose": "あえてシンプルに",
    "stepsTitle": "3ステップ。印象に残る演出。",
    "step1Title": "質問を書く",
    "step1Body": "アカウントやAPIキーなしで、リンクに収まる質問を入力します。",
    "step2Title": "演出を共有",
    "step2Body": "受け取った人は、どの画面でも上品な入力アニメーションを見られます。",
    "step3Title": "ChatGPTを開く",
    "step3Body": "最後に、質問を含んだURLでChatGPTが開きます。",
    "privacyLabel": "プライバシー重視の設計",
    "privacyTitle": "当サイトのサーバーには送信されません。",
    "privacyBody": "質問はリンク自体にエンコードされます。データベース、追跡Cookie、OpenAIキーは使用しません。",
    "footerIndependent": "独立したプロジェクトです。OpenAIまたはChatGPTとは提携していません。",
    "openChatGPT": "ChatGPTを開く",
    "homeAria": "Let Me Ask AI For You — ホーム",
    "toastWritePrompt": "まず質問を入力してください。",
    "toastLinkCopied": "リンクをクリップボードにコピーしました。",
    "toastManualCopy": "リンクを選択して手動でコピーしてください。",
    "toastShareFailed": "共有メニューを開けませんでした。",
    "shareTitle": "AIに説明してもらおう",
    "shareText": "この質問がChatGPTに入力される様子をご覧ください：",
    "navIllustrative": "イメージ用ナビゲーション",
    "shortcutsIllustrative": "イメージ用ショートカット",
    "newChat": "新しいチャット",
    "searchChats": "チャットを検索",
    "images": "画像",
    "plugins": "プラグイン",
    "research": "リサーチ",
    "optionsIllustrative": "イメージ用オプション",
    "plans": "プランと料金を見る",
    "settings": "設定",
    "help": "ヘルプ",
    "loginTitle": "あなた向けの回答を受け取る",
    "loginBody": "ログインすると、保存済みチャットに基づく回答、画像生成、ファイルアップロードを利用できます。",
    "signIn": "ログイン",
    "signUp": "無料で登録",
    "askAnything": "何でも聞いてください",
    "composerAria": "イメージ用メッセージ入力欄",
    "questionTyping": "質問を入力中",
    "disclaimer": "ChatGPTは誤ることがあります。重要な情報は確認してください。",
    "controlsAria": "シミュレーション操作",
    "pauseAnimation": "アニメーションを一時停止",
    "pause": "一時停止",
    "skipAnimation": "アニメーションをスキップ",
    "skip": "スキップ",
    "createAnother": "別のリンクを作成",
    "createLinkShort": "リンクを作成",
    "statusTypingQuestion": "質問を入力中",
    "statusPreparing": "準備中",
    "unofficialNote": "独立したビジュアルシミュレーション・OpenAI非提携",
    "fallbackTitle": "続行する準備ができました",
    "fallbackBody": "自動的に移動しない場合は、下のボタンを使用してください。",
    "copyQuestion": "質問をコピー",
    "statusOpeningConversation": "会話を開いています…",
    "statusPreviewDone": "プレビュー完了",
    "statusOpeningChatGPT": "ChatGPTを開いています…",
    "statusSendingChatGPT": "ChatGPTに送信中",
    "statusTyping": "入力中",
    "statusQuestionComplete": "質問の入力完了",
    "statusQuestionReady": "質問の準備完了",
    "statusPaused": "アニメーションを一時停止しました",
    "statusQuestionCopied": "質問をコピーしました。",
    "continueAnimation": "アニメーションを再開",
    "continue": "再開",
    "openInChatGPT": "ChatGPTで開く",
    "simulation": "シミュレーション",
    "autoDetected": "自動：{language}"
  },
  "zh-CN": {
    "metaHomeTitle": "Let Me Ask AI For You — 将问题变成链接",
    "metaHomeDescription": "创建一个精美链接，自动输入问题并打开 ChatGPT。",
    "metaPlayerTitle": "正在准备你的问题… — Let Me Ask AI For You",
    "themeLight": "使用浅色主题",
    "themeDark": "使用深色主题",
    "language": "语言",
    "automatic": "自动",
    "privacyPill": "无需 API · 无需注册",
    "eyebrow": "一种更有趣的回复方式",
    "heroPrefix": "让",
    "heroAccent": "AI 替你解释",
    "heroSuffix": "。",
    "heroCopy": "创建一个链接，在屏幕上输入问题，然后打开已准备好的 ChatGPT。",
    "questionLabel": "你希望对方问什么？",
    "questionPlaceholder": "例如：用简单的话解释天空为什么是蓝色的。",
    "typingRhythm": "输入速度",
    "speedFast": "快速",
    "speedNormal": "自然",
    "speedSlow": "戏剧化",
    "createMagicLink": "创建魔法链接",
    "shortcut": "创建链接",
    "resultReady": "链接已准备好",
    "resultTitle": "现在只需发送。",
    "resultBody": "对方会先看到问题被输入，然后进入 ChatGPT。",
    "copy": "复制",
    "copied": "已复制！",
    "preview": "预览",
    "testRealLink": "测试真实链接",
    "share": "分享",
    "promptInLink": "链接中的问题",
    "simplePurpose": "刻意保持简单",
    "stepsTitle": "三个步骤，一次难忘的效果。",
    "step1Title": "写下问题",
    "step1Body": "无需账号或 API 密钥，输入任何能放进链接的问题。",
    "step2Title": "分享这一幕",
    "step2Body": "接收者可以在任何屏幕上观看流畅的输入动画。",
    "step3Title": "打开 ChatGPT",
    "step3Body": "最后，浏览器会打开地址中已带问题的 ChatGPT。",
    "privacyLabel": "隐私优先设计",
    "privacyTitle": "不会向我们的服务器发送任何内容。",
    "privacyBody": "问题仅编码在链接本身中。本项目不使用数据库、跟踪 Cookie 或 OpenAI 密钥。",
    "footerIndependent": "独立项目，与 OpenAI 或 ChatGPT 无关联。",
    "openChatGPT": "打开 ChatGPT",
    "homeAria": "Let Me Ask AI For You — 首页",
    "toastWritePrompt": "请先输入一个问题。",
    "toastLinkCopied": "链接已复制到剪贴板。",
    "toastManualCopy": "请手动选择并复制链接。",
    "toastShareFailed": "无法打开分享菜单。",
    "shareTitle": "让 AI 来解释",
    "shareText": "看看这个问题如何被提交给 ChatGPT：",
    "navIllustrative": "示意导航",
    "shortcutsIllustrative": "示意快捷方式",
    "newChat": "新聊天",
    "searchChats": "搜索聊天",
    "images": "图片",
    "plugins": "插件",
    "research": "研究",
    "optionsIllustrative": "示意选项",
    "plans": "查看方案与价格",
    "settings": "设置",
    "help": "帮助",
    "loginTitle": "获取个性化回答",
    "loginBody": "登录后可根据已保存的聊天获得回答，还能创建图片和上传文件。",
    "signIn": "登录",
    "signUp": "免费注册",
    "askAnything": "问点什么",
    "composerAria": "示意消息输入框",
    "questionTyping": "正在输入问题",
    "disclaimer": "ChatGPT 可能会出错。请核实重要信息。",
    "controlsAria": "模拟控制",
    "pauseAnimation": "暂停动画",
    "pause": "暂停",
    "skipAnimation": "跳过动画",
    "skip": "跳过",
    "createAnother": "创建另一个链接",
    "createLinkShort": "创建链接",
    "statusTypingQuestion": "正在输入问题",
    "statusPreparing": "准备中",
    "unofficialNote": "独立视觉模拟 · 与 OpenAI 无关联",
    "fallbackTitle": "可以继续了",
    "fallbackBody": "如果没有自动跳转，请使用下方按钮。",
    "copyQuestion": "复制问题",
    "statusOpeningConversation": "正在打开对话…",
    "statusPreviewDone": "预览完成",
    "statusOpeningChatGPT": "正在打开 ChatGPT…",
    "statusSendingChatGPT": "正在发送到 ChatGPT",
    "statusTyping": "输入中",
    "statusQuestionComplete": "问题输入完成",
    "statusQuestionReady": "问题已准备好",
    "statusPaused": "动画已暂停",
    "statusQuestionCopied": "问题已复制。",
    "continueAnimation": "继续动画",
    "continue": "继续",
    "openInChatGPT": "在 ChatGPT 中打开",
    "simulation": "模拟",
    "autoDetected": "自动：{language}"
  }
}
